import React from 'react';
import { AiOutlineMenu } from 'react-icons/ai';
import { FiSettings, FiLock } from 'react-icons/fi';
import { useLocation } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';
import { useAuth } from '../../contexts/AuthContext';

const titleFromPath = (pathname: string) => {
  const routeTitles: Array<{ startsWith: string; title: string }> = [
    { startsWith: '/admin/clients/facilities/modules', title: 'Modules' },
    { startsWith: '/admin/clients/facilities', title: 'Facilities' },
    { startsWith: '/admin/clients/users', title: 'Users' },
    { startsWith: '/admin/roles', title: 'Roles' },
    { startsWith: '/admin/subscriptions', title: 'Subscriptions' },
    { startsWith: '/admin/remote-support', title: 'Remote Support' },
    { startsWith: '/admin/tickets', title: 'Tickets' },
    { startsWith: '/admin/servers', title: 'Servers' },
    { startsWith: '/admin/clients', title: 'Clients' },
    { startsWith: '/admin', title: 'Dashboard' },
  ];

  const match = routeTitles.find((item) => pathname === item.startsWith || pathname.startsWith(`${item.startsWith}/`));
  return match?.title || 'Dashboard';
};

const AdminNavbar: React.FC = () => {
  const location = useLocation();
  const { sidebarState, setSidebarState, screenSize, setThemeSettings } = useStateContext();
  const { user, lockScreen } = useAuth();

  const handleMenuToggle = () => {
    if (screenSize && screenSize <= 900) {
      setSidebarState(sidebarState === 'hidden' ? 'full' : 'hidden');
      return;
    }
    setSidebarState(sidebarState === 'full' ? 'collapsed' : 'full');
  };

  const sectionTitle = titleFromPath(location.pathname);
  const username = (user as any)?.username || 'admin';

  return (
    <div className="bg-base-100 border-b border-base-300 px-4 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={handleMenuToggle}
          className="btn btn-ghost btn-sm"
          aria-label="Toggle admin menu"
        >
          <AiOutlineMenu className="text-lg" />
        </button>
        <div>
          <p className="text-xs uppercase tracking-wide text-base-content opacity-60">Global Admin</p>
          <h1 className="text-lg font-semibold text-base-content">{sectionTitle}</h1>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button className="btn btn-ghost btn-sm" onClick={() => setThemeSettings(true)}>
          <FiSettings size={18} />
        </button>
        <button className="btn btn-ghost btn-sm" onClick={lockScreen} aria-label="Lock screen" title="Lock screen">
          <FiLock size={17} />
        </button>
        <span className="badge badge-primary badge-outline">Admin Mode</span>
        <span className="text-sm text-base-content opacity-80">{username}</span>
      </div>
    </div>
  );
};

export default AdminNavbar;
